import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-copy-to-clipboard' })
export class CopyToClipboardComponent {
	constructor(public element: HTMLElement) {
		this.element.addEventListener('click', () => {
			navigator.clipboard.writeText(window.location.href);
		});
	};
}

